export default __webpack_public_path__ + "static/media/langchain.b12a2b99.svg";